// extracted by mini-css-extract-plugin
export var actionButton = "_ie-0";
export var actionMenuContainer = "_ie-i";
export var bubble = "_ie-2";
export var bubbleActionMenu = "_ie-j";
export var bubbleContext = "_ie-6";
export var bubbleItems = "_ie-7";
export var customer = "_ie-3";
export var divider = "_ie-8";
export var fileList = "_ie-9";
export var hiddenComment = "_ie-o";
export var infoAbove = "_ie-a";
export var internal = "_ie-4";
export var lightActionButton = "_ie-1";
export var link = "_ie-b";
export var merchant = "_ie-5";
export var message = "_ie-c";
export var profilePicture = "_ie-e";
export var quillToolbarContainer = "_ie-f";
export var senderDate = "_ie-g";
export var senderDateCustomer = "_ie-h";
export var senderName = "_ie-d";
export var time = "_ie-k";
export var uploadedImage = "_ie-l";
export var username = "_ie-m";
export var xsmall = "_ie-n";